const initSwiperItem = () => {
  const swiperElement = document.querySelector('[data-swiper="item"]');
  if (!swiperElement) return;

  const swiperThumbs = document.querySelector('[data-swiper="item-thumbs"]');
  if (!swiperThumbs) return;

  const swiper = new Swiper(swiperThumbs, {
    spaceBetween: 4,
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesProgress: true,
    direction: 'vertical',

    breakpoints: {
      0: {
        direction: 'horizontal',
      },
      616: {
        direction: 'vertical',
      },
    },
  });

  const swiper2 = new Swiper(swiperElement, {
    slidesPerView: 1,
    loop: true,
    thumbs: {
      swiper: swiper,
    },
  });
};

export {initSwiperItem};
